import React, { useEffect, useState } from 'react';
import { ButtonGroup, Card, Button, Table, Form, Row, Col } from 'react-bootstrap';
import PageHeader from '../../layouts/layoutcomponents/PageHeader';
import { Fragment } from 'react';

import { API_OPERATIONS_VIEW } from '../../shared/consts/api'
import { useFetch, useTranslation } from '@np/np_webcomponentlib';
import dateFormat from 'dateformat';
import TypeOperationCheckboxList from '../../shared/MasterData/TypeOperationCheckboxList';
import { TypeOperationEnum, TypeSourseDateEnum, typeSourseDateLabels, TypeStatusOperationEnum } from '../../shared/MasterData/MasterDataTypes';
import StatusCheckboxList from '../../shared/MasterData/StatusCheckboxList';

//import { toast, Toaster } from 'react-hot-toast';
const Report = ({idBusiness, idProvider}) => {

    const [startDate, setStartDate] = useState<Date>()
    const [endDate, setEndDate] = useState<Date>()


    const [selectedStatuses, setSelectedStatuses] = useState<TypeStatusOperationEnum[]>([]);

    const [selectedTypeOperations, setSelectedTypeOperations] = useState<TypeOperationEnum[]>([]);

    const [selectedSourceDate, setSelectedSourceDate] = useState<TypeSourseDateEnum>(TypeSourseDateEnum.Added);
    const [showBusinessNames, setShowBusinessNames] = useState<boolean>(true);

    const getReport = () => {
        const body = {
            startDate: startDate,
            endDate: endDate,
            idBusiness: idBusiness,
            idProvider: idProvider,
            listTypeStatus: selectedStatuses,
            listTypeOperation: selectedTypeOperations,
            typeSourseDate: selectedSourceDate,
            showBusinessNames: showBusinessNames

        }
        fetch(`${API_OPERATIONS_VIEW}report/platform`, {
            method: "POST",
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('accessToken')}`
            },
            body: JSON.stringify(body),
        })
            .then(response => response.blob())
            .then(data => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(data);
                link.download = "ReportOperation.xlsx";
                link.click();
            })
            .catch((err) => {
                console.log(err);
            })
    }
  

  return (<Card>
    <Card.Header>
        <Card.Title as='h4'>{useTranslation('generateReport')}</Card.Title>
    </Card.Header>
    <Card.Body className="">
        {/* <Form className="form-horizontal"> */}

        <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('startDate')}</Form.Label>
                <Col md={9}>
                <Form.Control 
                    type="date" 
                    placeholder={useTranslation('startDate')} 
                    value={startDate ? startDate.toISOString().split('T')[0] : ''} 
                    onChange={e => setStartDate(e.target.value ? new Date(e.target.value) : undefined)} // Преобразуем строку в объект Date
                />
                </Col>
            </Col>

            <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('endDate')}</Form.Label>
                <Col md={9}>
                <Form.Control 
                    type="date" 
                    placeholder={useTranslation('endDate')} 
                    value={endDate ? endDate.toISOString().split('T')[0] : ''} 
                    onChange={e => setEndDate(e.target.value ? new Date(e.target.value) : undefined)} // Преобразуем строку в объект Date
                />
                </Col>
                </Col>

                <Col md={6}>
                    <StatusCheckboxList
                    selectedStatuses={selectedStatuses}
                    onChange={setSelectedStatuses}
                /></Col>


<Col md={6}>
                 
<TypeOperationCheckboxList
                selectedOperations={selectedTypeOperations}
                onChange={setSelectedTypeOperations}
            />
                 </Col>

            <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('sourceDate')}</Form.Label>
                <Col md={9}>
                    <Form.Select 
                        value={selectedSourceDate}
                        onChange={(e) => setSelectedSourceDate(e.target.value as TypeSourseDateEnum)}
                        disabled={selectedStatuses.some(status => 
                            status !== TypeStatusOperationEnum.Success && 
                            status !== TypeStatusOperationEnum.Failed
                        )}
                    >
                        {Object.values(TypeSourseDateEnum).map((value) => (
                            <option key={value} value={value}>
                                {typeSourseDateLabels[value as TypeSourseDateEnum]}
                            </option>
                        ))}
                    </Form.Select>
                </Col>
            </Col>

            <Col md={6} className="mt-3 mb-3">
                <Form.Check
                    type="checkbox"
                    id="showBusinessNames"
                    label="Показывать имена провайдеров/мерчантов"
                    checked={showBusinessNames}
                    onChange={(e) => setShowBusinessNames(e.target.checked)}
                />
            </Col>

                <Col>
                <Button onClick={() => { getReport() }}> {useTranslation('generateReport')} </Button>
    </Col>



            </Card.Body>
            </Card>
            
        )

}

export default Report